/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BranchCostAppraisalProductRequestDto {
  productId: string;
  price: number;
  productPurchaseStatus: BranchCostAppraisalProductRequestDto.ProductPurchaseStatusEnum;
}
// tslint:disable-next-line:no-namespace
export namespace BranchCostAppraisalProductRequestDto {
  export type ProductPurchaseStatusEnum = 'buy' | 'no_buy';
  export const ProductPurchaseStatusEnum = {
      Buy: 'buy' as ProductPurchaseStatusEnum,
      NoBuy: 'no_buy' as ProductPurchaseStatusEnum,
  };
}
